import React, { useState, useEffect } from 'react'
import "./styles/Policies.css"
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        setTimeout(() => setFadeIn(true), 1000); // Trigger fade-in after shrink animation
    }, []);

    return (
        <>
            {/* <Header /> */}
            <div className={`policies-page home-page ${fadeIn ? "show" : ""}`}>
                <div className='policies-container fade-in show'>
                    <div className='section section1'>
                        <div className='page-header'>
                            <h2>Privacy Policy for BunnyKlawz Nail Salon</h2>
                            <p>
                                Please click{" "}
                                <a
                                    href="https://www.instagram.com/bunnyklawz"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    here
                                </a>{" "}
                                to DM @bunnyklawz on Instagram for any questions!
                            </p>
                        </div>

                        <div className='policy-sections'>
                            <h4>Effective Date: April 27<sup>th</sup>, 2025</h4>
                            <p>At BunnyKlawz Nail Salon ("we," "our," "us"), your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you visit our website or book services with us.</p>

                            <h2>Information We Collect:</h2>
                            <ul>
                                <li><strong>Personal Information</strong>: Name, phone number, email address, and payment information.</li>
                                <li><strong>Appointment Details</strong>: Service history and scheduling preferences.</li>
                                <li><strong>Website Information</strong>: IP address, browser type, and browsing behavior.</li>
                            </ul>

                            <h2>How We Use Your Information:</h2>
                            <ul>
                                <li>To schedule and manage appointments.</li>
                                <li>To send appointment reminders and updates.</li>
                                <li>To improve our services and website experience.</li>
                                <li>To process payments securely.</li>
                            </ul>

                            <h2>How We Protect Your Information:</h2>
                            <p>We use reasonable security measures to protect your personal information from unauthorized access, use, or disclosure.</p>

                            <h2>Sharing Your Information:</h2>
                            <p>We do not sell or rent your information. We only share it when necessary to deliver services (e.g., payment processing).</p>

                            <h2>Your Choices:</h2>
                            <p>You may update or request deletion of your information by contacting us at [insert contact email].</p>
                        </div>

                    </div>

                    <Footer />
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy
